module.exports = __webpack_public_path__ + "img/show.8619571b.svg";